<template>
  <section
    class="article-hero-module-component"
    :class="{
      'no-text': data.no_text,
    }">
    <img
      v-if="data.enable_background_image && !data.no_text"
      class="background-image"
      src="@/assets/img/rev_ras_bg_top.svg"
      alt="Revmed Logo" />

    <img
      v-if="data.enable_background_image && data.no_text"
      class="background-image"
      :class="{
        'no-text': data.no_text,
      }"
      src="@/assets/img/outlined_logo_border.png"
      alt="Revmed Logo" />
    <div
      v-if="!data.no_text"
      class="hero-top">
      <div class="rr-container">
        <img
          v-if="data.add_image"
          ref="heroImageRef"
          :src="data.image.url"
          :alt="data.image.alt"
          class="hero-image" />

        <div
          ref="heroTextRef"
          class="hero-text">
          <div
            class="hero-title"
            v-html="data.hero_text" />

          <div
            v-if="data.add_subtitle"
            class="subtitle"
            v-html="data.hero_subtitle"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const heroTextRef = ref(null)
const heroImageRef = ref(null)

onMounted(() => {
  gsap.set(heroTextRef.value, {
    y: 20,
    opacity: 0,
  })

  gsap.set(heroImageRef.value, {
    y: -20,
    opacity: 0,
  })

  const animateText = () => {
    if (!heroTextRef.value) return

    if (props.data.add_image && heroImageRef.value) {
      gsap.to(heroImageRef.value, {
        y: 0,
        opacity: 1,
        ease: 'Power4.easeOut',
      })
    }

    gsap.to(heroTextRef.value, {
      y: 0,
      opacity: 1,
      duration: 1.2,
      delay: heroImageRef.value ? 0.2 : 0,
      ease: 'Power4.easeOut',
    })
  }

  animateText()
})
</script>

<style lang="scss" scoped>
.article-hero-module-component {
  @apply block bg-humble relative z-0 overflow-hidden;

  @apply relative py-[150px]
    lg:pt-[210px] md:pb-[150px] lg:pb-[50px] z-1;

  .background-image {
    @apply absolute hidden top-0 right-0 w-[749px] h-full z-[-1] object-contain object-bottom lg:block;

    &.no-text {
      @apply w-[400px] right-auto left-[calc(50%-180px)] lg:w-[649px] xl:w-[749px] h-auto object-center;
    }
  }

  &:before {
    @apply absolute z-2 bottom-0 left-0 w-full h-[50px] bg-white;
    content: '';
    @apply rounded-tl-[50px] md:rounded-tl-[60px] lg:rounded-tl-[80px];
  }

  &.no-text {
    @apply py-[100px] bg-balanced lg:py-[120px] lg:h-[370px];
  }

  .hero-top {
    @apply relative;

    .rr-container {
      @apply relative flex flex-col gap-8 lg:gap-10;

      .hero-image {
        @apply object-contain max-w-[420px] h-auto ml-0;
      }

      .hero-text {
        @apply relative md:max-w-[490px] lg:pb-10 lg:max-w-[880px];

        .hero-title {
          &:deep(h1) {
            @apply text-white font-FKDisplayALT text-[32px] leading-[1.2] tracking-[-0.8px]
              lg:text-[80px] lg:not-italic lg:font-normal lg:leading-[1.2] lg:tracking-[-1.2px];

            strong {
              @apply font-normal text-progressive;
            }
          }
        }

        .subtitle {
          @apply pt-5;

          :deep(p) {
            @apply text-[16px] leading-tight text-white lg:text-[22px];
          }
        }

        .bicolor-line-container {
          @apply relative overflow-hidden w-full;
        }

        .bicolor-line {
          @apply mt-6 h-[4px] w-[120px] lg:mt-6 lg:h-[5px] lg:w-[220px];
        }
      }
    }
  }
}
</style>
